var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Card, SkeletonBlock, Typography, } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { BuyItAgainAPI } from '../../../api/oms/order-history';
import { useCommonContext, useExperienceContext, usePurchaseHistoryContext, } from '../../../hooks/useContexts';
import { pushEventInfo } from '../../../utils/analytics';
import { getWindow } from '../../../utils/general';
import { getSvocId } from '../../../utils/user';
import { DateRanges } from '../../../utils/DateRanges';
import { FeatureSwitches } from '../../../constants/feature-switches';
export var BuyItAgain = function () {
    var _a;
    var _b = useState([]), buyAgainItems = _b[0], setBuyAgainItems = _b[1];
    var _c = useState(false), showError = _c[0], setShowError = _c[1];
    var isDesktop = useCommonContext().isDesktop;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var orderHistoryData = usePurchaseHistoryContext().orderHistoryData;
    var orderCount = (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orderCount) || 0;
    var getBuyItAgainData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    request = {
                        customerAccountId: getSvocId() || '',
                        startDate: DateRanges.last2Years.startDate,
                        endDate: DateRanges.last2Years.endDate,
                        offset: '8',
                    };
                    return [4 /*yield*/, BuyItAgainAPI(request)];
                case 1:
                    response = _b.sent();
                    if (response.data) {
                        setBuyAgainItems((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.buyAgainItems);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    setShowError(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (orderCount > 1 && !isConsumerApp) {
            getBuyItAgainData();
        }
    }, [orderCount]);
    if (isConsumerApp)
        return null;
    if (buyAgainItems.length === 0 && !showError) {
        return (React.createElement(Card, { href: "#", "data-testid": "buyItAgain", className: "".concat(isDesktop && FeatureSwitches.enableNewLoyaltySpendUI
                ? 'sui-w-1/2'
                : '') },
            React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between sui-w-full" },
                React.createElement(Typography, { weight: "bold", variant: "h5" }, "Buy It Again"),
                React.createElement(Typography, null, " View All ")),
            React.createElement("div", { className: "sui-flex sui-gap-3" }, __spreadArray([], Array(isDesktop && FeatureSwitches.enableNewLoyaltySpendUI ? 4 : 8), true).map(function (_e, i) { return (React.createElement("div", { className: "sui-mr-9", key: i },
                React.createElement(SkeletonBlock, { height: 14, width: 14 }))); }))));
    }
    if (showError) {
        return (React.createElement(Card, { href: "#", "data-testid": "buyItAgain", className: "".concat(isDesktop && FeatureSwitches.enableNewLoyaltySpendUI
                ? 'sui-w-1/2'
                : '') },
            React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between sui-w-full" },
                React.createElement(Typography, { weight: "bold", variant: "h5" }, "Buy It Again"),
                React.createElement(Typography, null, " View All ")),
            React.createElement("div", { className: "sui-flex sui-gap-3" },
                React.createElement(Typography, null, "We were unable to retrieve your Buy It Again details. Refresh the page and try again."))));
    }
    if (buyAgainItems.length > 0) {
        return (React.createElement(Card, { href: "https://".concat((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location.hostname, "/buyitagain"), className: "".concat(isDesktop && FeatureSwitches.enableNewLoyaltySpendUI
                ? 'sui-w-1/2'
                : ''), "data-testid": "buyItAgain", onClick: function () {
                pushEventInfo({
                    category: { primaryCategory: 'button submission' },
                    eventInfo: { eventName: 'Buy It Again' },
                    myAccount: { settings: 'Buy It Again button clicked' },
                });
            } },
            React.createElement("div", { className: "sui-flex sui-justify-between" },
                React.createElement(Typography, { style: { fontWeight: 'bold' }, variant: "h5" }, "Buy It Again"),
                React.createElement(Typography, null, " View All ")),
            React.createElement("div", { className: "sui-flex sui-gap-14 sui-max-h-16" }, buyAgainItems.map(function (el, i) {
                if (i <
                    (isDesktop && FeatureSwitches.enableNewLoyaltySpendUI ? 4 : 8)) {
                    return (el === null || el === void 0 ? void 0 : el.buyItAgainImage) ? (React.createElement("img", { width: "60px", height: "60px", src: el.buyItAgainImage, alt: el.itemDescFromCatalog, key: i })) : (React.createElement("div", { key: i },
                        React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/no-img.svg", alt: "Unavailable", width: "60px", height: "60px" })));
                }
                return null;
            }))));
    }
    return null;
};
